'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "checked", "value", "onChange"];
import { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { IndentWrapper, PanelItemUIFlex } from './FullScreenModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnclickableUICheckbox = styled(UICheckbox).withConfig({
  displayName: "PanelCheckbox__UnclickableUICheckbox",
  componentId: "sc-12xbq8m-0"
})(["pointer-events:none;"]);
export const PanelCheckbox = _ref => {
  let {
      children,
      checked,
      value,
      onChange
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const simulatedOnChangeHandler = useCallback(() => {
    onChange({
      target: {
        checked: !checked,
        type: 'checkbox',
        value
      }
    });
  }, [checked, onChange, value]);
  return /*#__PURE__*/_jsx(IndentWrapper, {
    children: /*#__PURE__*/_jsxs(PanelItemUIFlex, Object.assign({
      align: "center",
      justify: "between",
      onClick: simulatedOnChangeHandler
    }, restProps, {
      children: [children, /*#__PURE__*/_jsx(UnclickableUICheckbox, {
        "aria-label": "checkbox",
        checked: checked
      })]
    }))
  });
};
PanelCheckbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string
};
PanelCheckbox.defaultProps = {
  value: ''
};